import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Public from '@/public/Public.vue';
import Login from '@/public/login/Login.vue';
import Dashboard from '@/secure/dashboard/Dashboard.vue';
import Secure from '@/secure/Secure.vue';
import store from '@/store';
import UserFetchState from '@/objects/users/UserFetchState';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/public',
    name: 'Public',
    component: Public,
    beforeEnter: async (to, from, next) => {
      const isAuthenticated = !!Vue.$cookies.get('session_id');

      if (isAuthenticated) {
        if (!to.query.refer) {
          next({ path: '/secure/dashboard' });
          return;
        }
        if (to.query.refer.toString().startsWith('http')) {
          window.location.href = to.query.refer.toString();
          return;
        }
        next({ path: to.query.refer.toString() });
      } else {
        next();
      }
    },
    children: [
      {
        path: 'login',
        name: 'Login',
        component: Login,
        meta: { title: 'Login' },
      },
    ],
  },
  {
    path: '/secure',
    name: 'Secure',
    component: Secure,
    beforeEnter: async (to, from, next) => {
      let isGood = !!Vue.$cookies.get('session_id');

      if (isGood) {
        const userState: UserFetchState = await store.dispatch('self/getSelf');
        isGood = (userState === UserFetchState.GOOD || userState === UserFetchState.INTERNET_DOWN);

        if (userState === UserFetchState.INTERNET_DOWN) {
          setTimeout(() => {
            window.location.reload();
          }, 5000);
        }
      }

      if (isGood) {
        next();
      } else {
        next({
          path: '/public/login',
          query: { refer: to.path },
        });
      }
    },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { title: 'Dashboard' },
      },
    ],
  },
  { path: '*', redirect: '/public/login' },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title} | BEM Clients`;
  } else {
    document.title = 'DN';
  }
  next();
});
export default router;
